import { action, Action } from 'easy-peasy';

export type Permission =
  | 'aggregateDigitalTwin'
  | 'aggregateAccess'
  | 'listDigitalTwin'
  | 'listMilestone'
  | 'listRuleset'
  | 'listRule'
  | 'listSchemaCollection'
  | 'Create_DigitalTwin'
  | 'Update_DigitalTwin'
  | 'Delete_DigitalTwin'
  | 'Create_SchemaCollection'
  | 'Add_DigitalTwin_schemaCollections'
  | 'Update_SchemaCollection'
  | 'Delete_SchemaCollection'
  | 'Create_Milestone'
  | 'Delete_Milestone'
  | 'Update_Milestone'
  | 'Create_Ruleset'
  | 'Delete_Ruleset'
  | 'Update_Ruleset'
  | 'Create_Rule'
  | 'Delete_Rule'
  | 'Update_Rule'
  | 'Add_Rule_ruleRunStatus'
  | 'Remove_Rule_ruleRunStatus'
  | 'Add_SchemaCollection_milestones'
  | 'Add_Milestone_rules'
  | 'Add_Milestone_rulesets'
  | 'Add_SchemaCollection_rulesets'
  | 'Add_SchemaCollection_rules'
  | 'Add_Rule_rulesets'
  | 'Add_Ruleset_rules'
  | 'Remove_Milestone_rulesets'
  | 'Remove_Milestone_rules'
  | 'listAccess'
  | 'Create_Access'
  | 'Update_Access'
  | 'Delete_Access'
  | 'Add_Ruleset_milestones'
  | 'Add_Rule_milestones'
  | 'Remove_Rule_rulesets'
  | 'Remove_Rule_milestones'
  | 'listConsistencyCollection'
  | 'Create_ConsistencyCollection'
  | 'Update_ConsistencyCollection'
  | 'Delete_ConsistencyCollection'
  | 'Add_DigitalTwin_consistencyCollections'
  | 'Remove_DigitalTwin_consistencyCollections';

/** Holds groups of multiple permissions used for a single action. */
export type GroupedPermission =
  | 'CAN_CREATE_SCHEMA_COLLECTION'
  | 'CAN_CREATE_COLLECTION'
  | 'CAN_CREATE_RULESET'
  | 'CAN_CREATE_LINKED_RULESET'
  | 'CAN_CREATE_RULE'
  | 'CAN_CREATE_LINKED_RULE'
  | 'CAN_REMOVE_RULE_FROM_MILESTONE';

export const groupedPermissionsList: Record<GroupedPermission, Permission[]> = {
  CAN_CREATE_SCHEMA_COLLECTION: [
    'Create_SchemaCollection',
    'Add_DigitalTwin_schemaCollections',
  ],
  CAN_CREATE_COLLECTION: [
    'Create_Milestone',
    'Add_SchemaCollection_milestones',
  ],
  CAN_CREATE_RULESET: ['Create_Ruleset', 'Add_SchemaCollection_rulesets'],
  CAN_CREATE_LINKED_RULESET: [
    'Create_Ruleset',
    'Add_SchemaCollection_rulesets',
    'Add_Milestone_rulesets',
    'Add_Ruleset_milestones',
  ],
  CAN_CREATE_RULE: ['Create_Rule', 'Add_SchemaCollection_rules'],
  CAN_CREATE_LINKED_RULE: [
    'Create_Rule',
    'Add_SchemaCollection_rules',
    'Add_Rule_rulesets',
    'Add_Ruleset_rules',
    'Add_Rule_milestones',
    'Add_Milestone_rules',
  ],
  CAN_REMOVE_RULE_FROM_MILESTONE: [
    'Remove_Milestone_rules',
    'Remove_Rule_milestones',
  ],
};

export interface PermissionsResponse {
  role?: string;
  permissions?: Permission[];
}

export interface PermissionsModel {
  permissions?: Permission[];

  setPermissions: Action<PermissionsModel, Permission[]>;
}

export const permissionsModel: PermissionsModel = {
  permissions: [],

  setPermissions: action((state, permissions) => {
    state.permissions = permissions;
  }),
};
